'use strict';

var _ = require('lodash');

exports.firstName = firstName;
exports.fullName = fullName;
exports.lastName = lastName;
exports.isActualUser = isActualUser;

/**
 * Display full name of user
 *
 * @param {User}
 * @return {String}
 */
function fullName(user) {
  return _.get(user, 'profile.name.first') + ' ' + _.get(user, 'profile.name.last');
}

/**
 * Display first name of user
 *
 * @param {User}
 * @return {String}
 */
function firstName(user) {
  return _.get(user, 'profile.name.first');
}

/**
 * Display last name of user
 *
 * @param {User}
 * @return {String}
 */
function lastName(user) {
  return _.get(user, 'profile.name.last');
}

function isActualUser(user) {
  return user && user.__t && user.__t === 'User';
}